<template>
  <ContextMenu :id="id" :items="menu" align="right" />
</template>

<script>
import ContextMenuMixin from "mixins/ContextMenu";
import EnrollmentMixin from "mixins/Courses/HandlesCourseEnrollment";
import EventRequestCalendar from "components/pages/registration/classroom/partials/EventRequestCalendar";
import DetailsMenu from "../../pages/training/users/partials/DetailsMenu.vue";

export default {
  mixins: [ContextMenuMixin, EnrollmentMixin],

  components: {DetailsMenu, EventRequestCalendar },

  props: {
    mobile: { type: Boolean, default: false },
    custom: { type: Array, default: () => [] },
  },

  computed: {
    routeParam() {
      return { course: this.item.id };
    },

    isEnrolled() {
      return !!this.item.enrollment;
    },

    isPassed() {
      return (
        this.isEnrolled &&
        this.item.enrollment.completion_status == this.$root.constants.COMPLETION_PASSED
      );
    },

    menu() {
      if (this.mobile) {
        return _.concat(this.mobileMenu, this.custom);
      }

      let menu = _.concat([], this.custom);

      menu.push({
        label: "Details",
        action: () => {
          this.showDetailsPane("details");
        },
      });

      if (!!this.item.is_classroom) {
        menu.push({
          label: "Upcoming Events",
          action: () => {
            this.showDetailsPane("events");
          },
        });
      }

      if (!!this.item.show_trainer_bio) {
        menu.push({
          label: "Trainer Bio",
          action: () => {
            this.showDetailsPane("trainer");
          },
        });
      }

      if (!!this.item.show_downloads) {
        menu.push({
          label: "Downloads",
          action: () => {
            this.showDetailsPane("downloads");
          },
        });
      }

      if (!!this.item.show_feedback) {
        menu.push({
          label: "Course Reviews",
          action: () => {
            this.showDetailsPane("feedback");
          },
        });
      }

      if (this.isEnrolled) {
        menu.push({
          label: "Purchase Confirmation",
          action: () => {
            this.goToRoute("enroll.online.print.enrollment", {
              enrollment: this.item.enrollment.id,
            }, true);
          },
        });
      }

      if (!this.isEnrolled) {
        menu.push({
          label: "Add to My Wishlist",
          action: () => {
            this.axios
                .post(this.route("training.users.wishlist.store", { course: this.item.id }))
                .then(() => {
                  console.log('success');
                  this.eventBus.$emit("show-alert", "success", `"${this.item.name}" has been added to your Wishlist.`, true);
                })
                .catch(() => {});
          }
        })
      }

      if (this.isPassed) {
        menu.push({
          label: "Print Certificate",
          action: () => {
            this.goToRoute("training.courses.enrollments.certificate", {
              enrollment: this.item.enrollment.id,
            }, true);
          },
        });
      }

      if (!!this.item.can_enroll && !this.item.in_queue) {
        menu.push({
          label: "Register Myself",
          action: () => {
            this.enrollMyself(this.item);
          },
        });
      }

      if (!!this.item.can_enroll_others) {
        menu.push({
          label: "Register Others",
          action: () => {
            this.enrollOthers(this.item);
          },
        });
      }

      if (!!this.item.can_launch && !!this.item.launch_url) {
        menu.push({
          label: "Launch",
          action: () => {
            this.goToUrl(this.item.launch_url, true);
          },
        });
      } else if (!!this.item.show_prereq_notice) {
        menu.push({
          label: "Launch",
          action: () => {
            this.showPrerequisiteNotice();
          },
        });
      }

      if (
        !!this.item.is_classroom &&
        !!this.item.is_active &&
        this.$root.isManager
      ) {
        menu.push({
          label: "Request an Event",
          action: () => {
            this.showRequestAnEvent();
          },
        });
      }

      if ( !! this.item.show_survey_summary) {
        menu.push({
          label: "Export Survey Summary",
          action: () => {
            this.goToRoute("catalog.course.surveys.summary", this.routeParam);
          }
        });
      }

      menu.sort(this.sortMenu);
      return menu;
    },

    mobileMenu() {
      let menu = _.concat([], this.custom);

      menu.push({
        label: "Details",
        action: () => {
          this.goToRoute("catalog.course", this.routeParam);
        },
      });

      if (!!this.item.show_trainer_bio && !!this.item.trainer_company) {
        menu.push({
          label: "Trainer Bio",
          action: () => {
            this.goToRoute("catalog.trainer", {
              company: this.item.trainer_company.id,
            });
          },
        });
      }

      if (this.isEnrolled) {
        menu.push({
          label: "Purchase Confirmation",
          action: () => {
            this.goToRoute("enroll.online.print.enrollment", {
              enrollment: this.item.enrollment.id,
            }, true);
          },
        });
      }

      if (this.isPassed) {
        menu.push({
          label: "Print Certificate",
          action: () => {
            this.goToRoute("training.courses.enrollments.certificate", {
              enrollment: this.item.enrollment.id,
            }, true);
          },
        });
      }

      if (!this.isEnrolled && !this.item.in_queue && !!this.item.can_enroll) {
        menu.push({
          label: "Register Myself",
          action: () => {
            this.enrollMyself(this.item);
          },
        });
      }

      if (!!this.item.can_enroll_others) {
        menu.push({
          label: "Register Others",
          action: () => {
            this.enrollOthers(this.item);
          },
        });
      }

      if (!!this.item.can_launch && !!this.item.launch_url) {
        menu.push({
          label: "Launch",
          action: () => {
            this.goToUrl(this.item.launch_url, true);
          },
        });
      } else if (!!this.item.show_prereq_notice) {
        menu.push({
          label: "Launch",
          action: () => {
            this.showPrerequisiteNotice();
          },
        });
      }

      if ( !! this.item.show_survey_summary) {
        menu.push({
          label: "Export Survey Summary",
          action: () => {
            this.goToRoute("catalog.course.surveys.summary", this.routeParam);
          }
        });
      }

      menu.sort(this.sortMenu);
      return menu;
    },
  },

  methods: {
    showRequestAnEvent() {
      this.$modal(EventRequestCalendar, { course: this.item })
        .then(() => {})
        .catch(() => {});
    },
  },
};
</script>
